import { motion } from "framer-motion";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import Table from "@/components/elements/Table/Table";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import vistasuperplastImg from '@/assets/images/products/vistasuperplast.png';

// Animation variants
const fadeInUp = {
  initial: { opacity: 0, y: 50 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.2 },
};

const VistaSuperplast = () => {
  return (
    <div className=" 2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar
        title="Vista Superplast"
        subTitle="(Super Plasticizer Cum Water Reducing Admixture)"
      />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct alt="Vista Superplast"
          title="Description"
          imageUrl={vistasuperplastImg}
          content="Vista Superplast is a high water reducer and slump retaining admixture formulated using Sulphonated Naphthalene Formaldehyde, that is supplied as a light brown liquid suitable for concreting in all climates. Its special formulation allows for water reductions without any loss to workability, and also to produce higher quality concrete with reduced permeability. Vista Superplast complies with IS-9103: 1999 and BS: 5075 part 3, and also with ASTM-C-494 Type 'F' and Type 'A' depending on the dosages used."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <CustomLists
            items={[
              [
                "Provides significant increases in ultimate strength.",
                "Extends the setting time.",
                "Up to 15%-20% water reduction.",
                "Permeability of the concrete is reduced.",
                "Provides very high workability of concrete mixes without addition of extra water.",
              ],
              [
                "Produces floatable concrete.",
                "Reduced risk of segregation and bleeding.",
                "Improved quality - produces denser and more durable concrete.",
                "Permeability of the concrete is reduced.",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Uses">
          <Paragraph content="Vista Superplast is recommended for use in columns, beams, shotcrete, foundation and slender components with packed reinforcement, floor slabs, and ceilings." />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
          <Table
            items={{
              headings: [],
              rows: [
                ["Aspect", "Light Brown Liquid"],
                ["Specific Gravity", "1.20 ± / - 0.02 @ 27°C"],
                ["Chloride Content", "NIL (As Per BS : 5075)"],
                ["pH", "> 6"],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Precaution">
          <Paragraph content="Health & Safety Instruction: Vista Superplast is non-toxic. Any splashes on the skin should be washed immediately with water." />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaSuperplast;
